import {Injectable} from '@angular/core';
import {Observable} from 'rxjs/Observable';
import {apiEndpoints} from '../../app.constants';
import {InfluencerGroupNew, BulkUploadInfluencer} from '../../../models/influencer-group';
import 'rxjs/add/operator/map';
import {BackendHttpService} from '../../core/backend-http.service';
import {ErrorTemplate} from '../../../models/ErrorTemplate';
import {StringUtils} from '../../utils/string.utils';
import {BlockedReason, WallType} from '../../../models/user';

@Injectable()
export class InfluencerGroupsService extends BackendHttpService<any> {

  getInfluencerGroups(companyId): Observable<any> {
    const apiUrl = apiEndpoints.groups;
    const params = {
      companyId: companyId
    };
    return this.get(apiUrl, params).map((res) => res ? res.data : null);
  }

  getInfluencerGroupShortList(companyId): Observable<any[]> {
    const apiUrl = apiEndpoints.influencerGroupShortList;
    const params = {
      companyId: companyId
    };
    return this.get(apiUrl, params).map((res) => res ? res.data : []);
  }

  createInfluencerGroup(postData: InfluencerGroupNew): Observable<any> {
    return this.post(apiEndpoints.addNewInfluencerGroup, JSON.stringify(postData));
  }

  deleteInfluencerGroup(influencerGroupId: number): Observable<any> {
    return this.post(apiEndpoints.deleteInfluencerGroup, JSON.stringify({id: influencerGroupId}));
  }

  public validateGroup(newGroup: InfluencerGroupNew): ErrorTemplate[] {
    const errors: ErrorTemplate[] = [];
    if (!newGroup.influencerGroupName || StringUtils.trim(newGroup.influencerGroupName) === '') {
      errors.push({
        name: 'group_name',
        message: this.translate.instant('group_influencers.group_name_mandatory')
      });
    }
    return errors;
  }

  public extractLimitInfoFromErrorMessage(errorMsg, numberAddedItem, maxValue, isCamapaign) {
    const numb = errorMsg.match(/\d+/g);
    if (numb.length === 1) {
      return {
        blockedReason: BlockedReason.ACCOUNT_WALL,
        wallType: WallType.USAGE_LIMIT,
        wallName: isCamapaign ? 'Campaign Limit' : 'Group Limit',
        maxValue,
        desiredValue: maxValue + numberAddedItem
      };
    } else {
      return {
        blockedReason: BlockedReason.ACCOUNT_WALL,
        wallType: WallType.USAGE_LIMIT,
        wallName: isCamapaign ? 'Selection Limit Campaigns' : 'Selection Limit Groups',
        maxValue,
        desiredValue: Number(numb[0]) + (maxValue - Number(numb[1]))
      };
    }
  }

  public searchGroupByTerm(companyId, searchTerm) {
    const data = {
      companyId,
      searchValue: searchTerm
    };
    return this.get(apiEndpoints.searchGroups, data).map(res => res ? res.data : []);
  }

  public uploadBulkInfluencer(influencerGroupId: number, bulkUploadInfluencerData: BulkUploadInfluencer): Observable<any> {
    return this.post(apiEndpoints.bulkUploadInfluencer.replace(':influencerGroupId', influencerGroupId.toString()), JSON.stringify(bulkUploadInfluencerData))
        .map(res => res);
  }
}



// WEBPACK FOOTER //
// ./src/app/main/influencer-groups/influencer-groups.service.ts